import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";

import { putIleggelseEttersendelserTilGodkjenning as putIleggelseEttersendelserTilGodkjenningAction } from "../../../../actions/ettersendelserActions";
import { getIleggelse as getIleggelseAction } from "../../../../actions/ileggelserActions";

export default function SendTilGodkjenningContainer({
  latestEttersendelseId,
  reloadHistorikk,
}) {
  const ileggelse = useSelector((state) => state.ileggelse);
  const dispatch = useDispatch();

  const getIleggelse = (id) => dispatch(getIleggelseAction(id));
  const putIleggelseEttersendelserTilGodkjenning = (id, data) =>
    dispatch(putIleggelseEttersendelserTilGodkjenningAction(id, data));

  const handleApiCall = (ettersendelseId, data) => {
    return putIleggelseEttersendelserTilGodkjenning(ettersendelseId, data)
      .then(() => {
        getIleggelse(ileggelse.id);
        reloadHistorikk();
        return Promise.resolve();
      })
      .catch((error) => Promise.reject(error));
  };

  if (
    latestEttersendelseId &&
    ileggelse.isTilEttersendelse &&
    !ileggelse.isMakulert &&
    ileggelse.forsinketMakuleringStatus &&
    !ileggelse.forsinketMakuleringStatus.deletePossible &&
    !ileggelse.isBetalt
  ) {
    return (
      <ModalGenericPostCancelContainer
        id={latestEttersendelseId}
        apiCallData={{ tilGodkjenning: true }}
        modalTitle={`Send ileggelse ileggelse ${ileggelse.ileggelsesnummer} til godkjenning`}
        submitButtonText="Send til godkjenning"
        submittingButtonText="Sender til godkjenning..."
        successPostCallFlashMessage="Endring fullført"
        errorPostCallFlashMessage="Endring feilet"
        handleApiCall={handleApiCall}
        openModalComponentFunction={(props) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={props.openModal}
          >
            Send til godkjenning
          </Button>
        )}
      >
        <p>{`Vil du sende ileggelse ${ileggelse.ileggelsesnummer} til godkjenning?`}</p>
      </ModalGenericPostCancelContainer>
    );
  }
  return <span />;
}

SendTilGodkjenningContainer.propTypes = {
  latestEttersendelseId: PropTypes.string,
  reloadHistorikk: PropTypes.func,
};
